import type { FigmaIconProps } from './types';

export const IconFigmaEuro = ({ size = 16, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66667 6.66667H10.6667"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66667 9.33333H8.66667"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6667 4C11.718 3.13843 10.4815 2.66282 9.2 2.66667C8.50836 2.67537 7.8252 2.82022 7.18954 3.09297C6.55389 3.36571 5.97818 3.761 5.49531 4.25626C5.01243 4.75151 4.63184 5.33704 4.37528 5.9794C4.11871 6.62175 3.99119 7.30836 4 8C3.99119 8.69164 4.11871 9.37825 4.37528 10.0206C4.63184 10.663 5.01243 11.2485 5.49531 11.7437C5.97818 12.239 6.55389 12.6343 7.18954 12.907C7.8252 13.1798 8.50836 13.3246 9.2 13.3333C10.4815 13.3372 11.718 12.8616 12.6667 12"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
